import { useQueryClient } from '@tanstack/react-query';

import { callIsFreshPick } from '@app/client/resources/competitions';
import { useFantasyMetadataStore } from '@app/store/zustand';

const FRESH_COLLECTION_CACHE = 'fresh_collection_cache';

export function useCheckIfFreshCollection() {
    const queryClient = useQueryClient();
    const { currentGame } = useFantasyMetadataStore();
    const currentGameId = currentGame?.id;

    return async (collectionSlugs: string[]) => {
        if (!currentGameId || !collectionSlugs?.length) return;
        const slugString = collectionSlugs.join(',');
        if (!collectionSlugs) {
            return;
        }
        const cache = [FRESH_COLLECTION_CACHE, currentGameId, slugString];
        const isFreshResponse = await queryClient.ensureQueryData({
            queryKey: cache,
            queryFn: ({ signal }) =>
                callIsFreshPick({
                    competitionSlug: currentGameId || '',
                    query: { slugs: slugString },
                    settings: { signal },
                }),
            retry: false,
        });
        if (isFreshResponse.ok && isFreshResponse.value) {
            return isFreshResponse.value.slugs;
        }
    };
}
